import * as React from 'react';
import {
  BaSeTextArea,
  BaSeCheckbox,
  BaSeInputList,
  BaSeTheme,
} from '@base/react';
import { LabelTitle } from '../components/LabelTitle';

const limitLength = (max) => (val) => val.slice(0, max);

export const DetailedInfoSection = ({
  formData,
  availableOptions,
  onFieldChange,
  onToggleCheckbox,
  onAddModule,
  onRemoveModule,
}) => {
  return (
    <>
      <BaSeTextArea
        label="Objetivo"
        maxValue={680}
        onChange={(e) => onFieldChange('objetivo', e, limitLength(680))}
        placeholder="Digite um objetivo do curso para o cliente"
        rows={3}
        textSize="medium"
        value={formData.objetivo}
      />
      <div>
        <LabelTitle
          label="Público"
          subTitle="Selecione os públicos desse produto"
        />
        <div
          style={{
            display: 'flex',
            flexFlow: 'column',
            gap: 6,
            padding: '2px 0',
          }}
        >
          {availableOptions.publico?.map((item) => (
            <BaSeCheckbox
              key={item.id}
              align="top-left"
              color="default"
              label={item.label}
              checked={item.id in (formData.publico ?? {})}
              onChange={() => onToggleCheckbox(item.id, 'publico')}
              size="medium"
            />
          ))}
        </div>
      </div>
      <div>
        <BaSeInputList
          ActionisDisabled
          buttonAction={(value) => onAddModule(value)}
          label="Modulo"
          subLabel="Opcional"
          placeholder="Digite cada título de módulo e adicione à lista"
          listItems={{
            columnNum: 1,
            direction: 'row-reverse',
            gap: '10px',
            listActions: [
              {
                ActionisDisabled: false,
                color: BaSeTheme.colors.institucionais.azulSebrae20,
                nameIcon: 'trash-alt',
                size: 'small',
                sizeIcon: 'small',
                listAction: (e) => onRemoveModule(e?.id),
              },
            ],
            valuesList: formData.listaModulo?.map((ele, index) => ({
              id: index,
              label: `${index + 1}) ${ele}`,
            })),
          }}
          nameButton="plus"
          typeButton="base-button"
          value=""
          valueButton="Adicionar"
          expandToMaxWidth
        />
      </div>
    </>
  );
};
